var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFecharSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "30px",
    viewBox: "0 0 29 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Limpar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Home_Pesquisa_avan\\xE7ada",
    transform: "translate(-438.000000, -1095.000000)",
    fill: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "pesquisa_avan\\xE7ada",
    transform: "translate(52.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(2.000000, 545.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.873772,76 C410.305761,76 409.768247,75.7751052 409.364159,75.3748686 L398.499523,64.5113039 L387.634888,75.3748686 C387.2308,75.7751052 386.697098,76 386.129087,76 C385.561077,76 385.023563,75.7751052 384.623287,75.3748686 C383.792238,74.5439012 383.792238,73.1945321 384.623287,72.3635647 L395.487923,61.4961882 L384.623287,50.6326236 C383.792238,49.8054679 383.792238,48.4522871 384.623287,47.6251314 C385.023563,47.2210831 385.561077,47 386.129087,47 C386.697098,47 387.2308,47.2210831 387.634888,47.6213197 L398.499523,58.4886961 L409.364159,47.6213197 C409.768247,47.2210831 410.305761,47 410.873772,47 C411.441783,47 411.975484,47.2210831 412.379572,47.6213197 C413.206809,48.4522871 413.206809,49.8054679 412.379572,50.6326236 L401.511124,61.4961882 L412.379572,72.3635647 C413.206809,73.1945321 413.206809,74.5439012 412.379572,75.3748686 C411.975484,75.7751052 411.441783,76 410.873772,76",
    id: "Fill-2332-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFecharSelect);
export default __webpack_public_path__ + "static/media/fechar-select.4d112c615c18ef7103da63147befccb8.svg";
export { ForwardRef as ReactComponent };